import { Sprite, filters, WRAP_MODES } from 'pixi.js';
import { Ripple } from './Ripple';
import { app } from '../app';

export class RippleGen {
    constructor(width, height, cont) {

        this.world = cont;
        this.time = 0;
        this.displacementSprite = new Sprite.from("displacement-sprite");
        this.displacementFilter = new filters.DisplacementFilter(this.displacementSprite);
        this.displacementFilter.autoFit = true;
        this.displacementSprite.texture.baseTexture.wrapMode = WRAP_MODES.MIRRORED_REPEAT;
        this.displacementSprite.scale.y = 1;
        this.displacementSprite.scale.x = 1;
        this.displacementSprite.anchor.set(0.5);

        this.world.addChild(this.displacementSprite);
        this.world.interactive = true;
        this.world.filters = [this.displacementFilter];

        this.ripples = [];
        this.world.filters = [this.displacementFilter, ...this.ripples.map(f => f.filter)];



        this.createRipple();
    }

    createRipple() {
        this.ripples.push(new Ripple(0, 0, this.world));
        this.world.filters = [this.displacementFilter, ...this.ripples.map(f => f.filter)];
    }

    update(dt) {
        this.time += dt;
        if (this.ripples.length < 3 && this.time > 100) {
            this.createRipple();
            this.time = 0;
        }
        this.ripples.forEach(ripple => ripple.update(dt));
    }
}
